(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    (function () {
    var _lastFetchedProductId = null;

    /* ── Recommendations fetch ─────────────────────────── */
    function fetchUpsellRecommendations(upsellEl, productId) {
      if (!productId || productId === _lastFetchedProductId) return;

      var limit = parseInt(upsellEl.dataset.upsellLimit || '4', 10);
      var track = upsellEl.querySelector('[data-upsell-track]');
      if (!track) return;

      _lastFetchedProductId = productId;

      fetch(
        '/recommendations/products?section_id=cart-upsell-recommendations' +
        '&product_id=' + productId +
        '&limit=' + limit +
        '&intent=related'
      )
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var cards = doc.querySelectorAll('.cu-card');
          track.innerHTML = '';
          if (cards.length === 0) {
            upsellEl.style.display = 'none';
            return;
          }
          cards.forEach(function (card) { track.appendChild(card); });
        })
        .catch(function () {
          upsellEl.style.display = 'none';
          _lastFetchedProductId = null;
        });
    }

    function tryInitUpsell() {
      var upsellEl = document.querySelector('.cart-upsell[data-upsell-source="recommendations"]');
      if (!upsellEl) return;

      var productId = upsellEl.dataset.upsellProductId;

      if (productId) {
        fetchUpsellRecommendations(upsellEl, productId);
      } else {
        /* Product ID not rendered server-side (cart was empty on page load) — fetch from cart API */
        fetch('/cart.json')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (cart.items && cart.items.length > 0) {
              var pid = String(cart.items[0].product_id);
              upsellEl.dataset.upsellProductId = pid;
              fetchUpsellRecommendations(upsellEl, pid);
            } else {
              upsellEl.style.display = 'none';
            }
          })
          .catch(function () { upsellEl.style.display = 'none'; });
      }
    }

    /* ── Listen for cart drawer open ───────────────────────
       dialog:open is NOT bubbling — add listener directly on
       cart-drawer-component once the DOM is ready.           */
    function bindDrawerOpenListener() {
      var drawerEl = document.querySelector('cart-drawer-component');
      if (drawerEl) {
        drawerEl.addEventListener('dialog:open', tryInitUpsell);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindDrawerOpenListener);
    } else {
      bindDrawerOpenListener();
    }

    /* ── Remove added product + reveal reserve card ─────── */
    function revealNextReserve(track) {
      var reserve = track.querySelector('.cu-card--reserve');
      if (reserve) {
        reserve.classList.remove('cu-card--reserve');
        reserve.removeAttribute('aria-hidden');
        reserve.style.opacity = '0';
        requestAnimationFrame(function () {
          reserve.style.transition = 'opacity 0.3s';
          reserve.style.opacity = '1';
        });
      }
    }

    function removeCardFromCarousel(productId) {
      var track = document.querySelector('.cart-upsell__track[data-upsell-track]');
      if (!track) return;
      var card = track.querySelector('.cu-card:not(.cu-card--reserve)[data-product-id="' + productId + '"]');
      if (!card) return;
      var w = card.offsetWidth;
      card.style.transition = 'opacity 0.2s';
      card.style.opacity = '0';

      /* Collapse width after fade */
      setTimeout(function () {
        card.style.transition = 'max-width 0.25s, margin 0.25s';
        card.style.maxWidth = w + 'px';
        card.style.overflow = 'hidden';
        requestAnimationFrame(function () {
          card.style.maxWidth = '0';
          card.style.marginRight = '0';
        });
        setTimeout(function () {
          card.remove();
          /* Only reveal a reserve if this is a collection carousel */
          var upsellEl = document.querySelector('.cart-upsell[data-upsell-source="collection"]');
          if (upsellEl) revealNextReserve(track);
        }, 280);
      }, 220);
    }

    document.addEventListener('cart:update', function (e) {
      var productId = e.detail && e.detail.data && e.detail.data.productId;
      if (productId) {
        removeCardFromCarousel(String(productId));
        /* Refresh recommendations with new first cart item */
        _lastFetchedProductId = null;
        var upsellEl = document.querySelector('.cart-upsell[data-upsell-source="recommendations"]');
        if (upsellEl) {
          upsellEl.dataset.upsellProductId = '';
          tryInitUpsell();
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
